
<template>
  <page class="ab-screen">
    <unbounce-poster
      paragraph="Don't <span style='font-weight: bold; font-style: italic'>give</span> your data to Big Tech firms, <span style='font-weight: bold; font-style: italic'>rent</span> it out to advertisers and make them pay you for it."
    >
      <div class="column">
        <sign-up-form />
      </div>
    </unbounce-poster>
  </page>
</template>

<script>
import Page from '@/components/common/Page.vue';
import UnbouncePoster from '@/components/unbounce/UnbouncePoster.vue';
import SignUpForm from '@/views/ab/SignUpForm.vue';

export default {
  components: {
    Page,
    UnbouncePoster,
    SignUpForm,
  },
};
</script>